import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/bank-logo/snapp-pay-blue.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/achievement-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/achievment-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/become-seller-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/best-product-coverr.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/blog-cover.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/bundle.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/course-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/course-bg.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/course-img.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/demo-cover.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/hero-box.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/menu-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/product-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/product-cover.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/sample-banner-mobile.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/sample-slide.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/story-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/ticket-guid.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/zhaket-academy.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/banners/zhaket-service-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/aboutBG.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/affiliate-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/auth-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/avatar.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/become-seller-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/best-seller.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/camma.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/cart-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/company-members.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/contactus-background.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/home_screen.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/home-bg-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/home-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/no-image-product-cover.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/remove-cart-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/rotating-slider-bg.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/spotlight-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/zhaket_location.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/common/zhk_logo_bg.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/banimode.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/digikala.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/divar.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/fidibo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/flightio.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/hamyar.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/khanoumi.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/miare.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/nobitex.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/sibapp.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/company-logo/sibche.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/errors/403.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/errors/404.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/errors/410.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/errors/429.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/errors/500.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/errors/errorbg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/add-blue.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/add-comment-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/add-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/add-orange.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/add-to-cart-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/add.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/affiliate-label.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/automatic-update.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/become-seller.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/bell-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/bg-table-contents.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/black-ticket-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/blue-loading.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/bookmark.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/bulb.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/cart-gradient.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/changelog.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/check-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/checkbox.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/comment-tree-branch.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/comments.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/contact-avatar-1.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/contact-avatar-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/contact-avatar-3.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/content-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/dashboard.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/default-medal.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/digit-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/discount.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/dislike-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/dislike.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/download-icon-orange.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/download-icon-white.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/download.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/edit.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/error-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/extremedesign.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/eye_with_square.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/faq.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/fire.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/gallery.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/guarantee.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/guard.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/highlight-item.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/hot-product-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/info-alert-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/info-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/ir-map.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/iranian-products-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/like-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/like.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/linkedin-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/location-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/login-to-comment.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/logout.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/mahdisweb.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/main-products-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/medal-based-filter-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/medal.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/messageStar.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/minus-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/minus.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/money-back-guarantee.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/nagatheme.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/orange-loading.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/orange-profile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/pannel_ticket_icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/pause.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/permanent-support.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/phone_call_icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/play.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/plus-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/product-categories-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/productsList.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/question-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/question.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/related-product-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/reply.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/sale-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/setting.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/share-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/shield.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/shopping-cart.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/show-live-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/special-products-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/star-gradient.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/success-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/support-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/tag-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/telegram-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/term-browser.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/term-email.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/term-pass.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/ticket-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/twitter-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/unavailable-products-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/updater.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/vendor-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/verified.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/warning-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/whatsapp-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/white-loading.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/yoast-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/zhaket-dark-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/zhaket-licenced-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/zhaket-light-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/icons/zhaket-orange-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/e-namad.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/zhk-brown-sm.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/zhk-dark-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/zhk-gray-sm.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/zhk-green-sm.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/zhk-light-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/zhk-orange-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/logo/zhk-white-sm.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/app/contact/components/contactUsCard/index.tsx");
